<template>
    <div>
        <g-row class="g-mt-8">
            <g-column>
                <g-typography tag="h3" font-weight="semibold" text-align="center" class="g-mb-5">
                    Remove Payout Method?
                </g-typography>

                <g-typography tag="p" class="g-mb-7">
                    Removing it means you won't be able to use this payout method for transfers without adding it again.
                    This cannot be undone.
                </g-typography>
            </g-column>
        </g-row>

        <g-row type="flex" align="middle" justify="space-around" class="g-mb-4">
            <g-column>
                <g-button
                    type="danger"
                    shape="round"
                    size="large"
                    :loading="isSubmitting"
                    :disabled="isSubmitting"
                    theme="live"
                    @click="handleRemove()"
                >
                    Yes, remove this payout method
                </g-button>
            </g-column>
        </g-row>

        <g-row type="flex" align="middle" justify="space-around" class="g-mb-4">
            <g-column>
                <g-button theme="live" :border="false" :shadow="false" @click="handleCancel">Cancel</g-button>
            </g-column>
        </g-row>
    </div>
</template>

<script>
    import { PAYOUT_METHOD_REMOVED_DEFAULT_FAILED_MESSAGE } from '../../../../../app-v2/constants/payouts';
    import useToggle from '../../../../composables/use-toggle';
    import usePayoutMethods from '../../../../composables/use-payout-methods';
    import useMessage from '../../../../composables/use-message';
    import useContactStore from '../../../../../stores/contact';

    export default {
        name: 'RemovePayoutMethod',

        props: {
            payoutMethod: {
                type: Object,
                default: null
            },
            isDefault: {
                type: Boolean,
                default: false
            }
        },

        setup(props, context) {
            const contact = useContactStore().data;
            const { message } = useMessage();
            const { currentValue: isSubmitting, setTrue: submitting, setFalse: doneSubmitting } = useToggle(false);

            const handleRemove = () => {
                if (props.isDefault) {
                    message.defaultError(PAYOUT_METHOD_REMOVED_DEFAULT_FAILED_MESSAGE);
                    return;
                }

                submitting();

                const { deletePayoutMethod } = usePayoutMethods();
                deletePayoutMethod(contact.id, props.payoutMethod?.id)
                    .then(() => {
                        context.emit('success');
                    })
                    .catch((error) => {
                        message.responseError(error);
                    })
                    .finally(() => {
                        doneSubmitting();
                    });
            };

            const handleCancel = () => {
                context.emit('cancel');
            };

            return {
                handleRemove,
                handleCancel,

                isSubmitting
            };
        }
    };
</script>

<style lang="scss" scoped>
    .ant-btn-danger {
        padding: 0 $g-spacing-8 !important;
    }
</style>
